
import { IExtension, IRelease } from '@/types/models';
import { defineComponent, PropType } from 'vue';
import utils from '@/utils';

interface IState {
  tabType: string;
}

export default defineComponent({
  props: {
    extension: {
      type: Object as PropType<IExtension>,
      required: true,
    },
    releases: {
      type: Object as PropType<IRelease>,
      required: true,
    },
  },
  data() {
    return {
      tabType: 'Details',
    } as IState;
  },
  methods: {
    getResourceState(extension: IExtension) {
      return utils.getResourceState(extension.state, extension.isFeatured);
    },

    getDownloadReleaseUrl(release: IRelease) {
      return `https://dl.sscms.com/extensions/${this.extension.userName}/${this.extension.name}/${this.extension.userName}.${this.extension.name}.${release.version}.zip`;
    },
  },
  watch: {
    extension() {
      this.tabType = 'Details';
    },
  },
});
